import target from '../views/target/index.vue'
import target_create from '../views/target/create.vue'
import target_edit from '../views/target/edit.vue'
import target_import from '../views/target/import.vue'

const routes = [
  {
    path: "/target",
    name: "target",
    component: target,
    meta: { authOnly: true },
  },
  {
    path: "/target/create",
    name: "target_create",
    component: target_create,
    meta: { authOnly: true },
  },
  {
    path: "/target/edit/:year/:uuid",
    name: "target_edit",
    component: target_edit,
    meta: { authOnly: true },
  },
  {
    path: "/target/import",
    name: "target_import",
    component: target_import,
    meta: { authOnly: true },
  },]

export default routes
